export const base_url = "/react/template";
